var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "claim-type"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("理赔类型")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("状态")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "200px"
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, _vm._l(_vm.statusSelectList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key,
        label: item.name
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-button", {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _vm.isAuth("home.claimsTypeStore") ? _c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.onAdd("add");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增类型")))]) : _vm._e()], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.tableData,
      expandIconColumnIndex: 1,
      bordered: "",
      pagination: _vm.pagination,
      rowKey: "claimsTypeId",
      defaultExpandAllRows: true
    },
    on: {
      change: _vm.tablePageChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (_, record, index) {
        return [_vm._v(_vm._s(record.isChild ? "" : (_vm.pagination.current - 1) * _vm.pagination.pageSize + Number(index + 1)))];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_vm.isAuth("home.claimsSortUpdate") ? _c("a-switch", {
          attrs: {
            "checked-children": _vm.$t("已启用"),
            "un-checked-children": _vm.$t("已禁用"),
            checked: _vm.isChecked(text === 1)
          },
          on: {
            change: checked => _vm.switchChange(checked, record.claimsTypeId)
          }
        }) : _c("span", [_vm._v(_vm._s(text === 1 ? _vm.$t("已启用") : _vm.$t("已禁用")))])];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [_vm.isAuth("home.claimsSortEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onEdit(record.claimsTypeId);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.claimsSortDelete") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e(), _vm.isAuth("home.claimsTypeStore") ? _c("a-button", {
          attrs: {
            type: "add"
          },
          on: {
            click: function ($event) {
              return _vm.onAdd("add", record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("新增子类型")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("add-modal", {
    ref: "addRef",
    on: {
      save: _vm.searchFun
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };